export const logoColors = { logo1: "#D9ECF3", logo2: "#E84452", logo3: "#01344F", logo4: "#78C7D0", logo5: "#8EC695", logo6: "#3FB7B0" };
const colors = { "Recrutement": "#66BEC8", "Default": "#66BEC8", "realisation": "#E84452" };
const getTagColor = (tag, type) => { return colors[tag] || colors[type] || colors.Default; };
export default getTagColor;
